import type { Film } from "@/mocks/films";

export default function FilmCard({ film }: { film: Film }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-400">
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={film.cover}
          alt={`${film.title} 海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-1 font-label text-[11px] text-background-50">
          {film.genre}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-primary-500 px-2 py-1 font-label text-[11px] text-background-50">
          <i className="ri-star-fill text-[10px]"></i>
          {film.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base text-foreground-950">{film.title}</h3>
        <div className="mt-1 flex flex-wrap items-center gap-x-2 text-xs text-foreground-500">
          <span>{film.year}</span>
          <span aria-hidden="true">·</span>
          <span>{film.region}</span>
          <span aria-hidden="true">·</span>
          <span>{film.duration}</span>
        </div>
        <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-foreground-600">{film.summary}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {film.tags.map((tag) => (
            <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
              {tag}
            </span>
          ))}
        </div>
        <div className="mt-auto flex items-center justify-between pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {film.views}
          </span>
          <span className="flex items-center gap-1 text-primary-700">
            <i className="ri-movie-2-line"></i>
            中字高清
          </span>
        </div>
      </div>
    </article>
  );
}